import { api } from 'app/utils/api/helpers'

/**
 * Update utility provider reference ID for an agency
 * @param {string} agencyId - The agency ID
 * @param {string} referenceId - The reference ID to set
 * @returns {Promise} API response with updated reference ID
 */
export const updateUtilityProviderReferenceId = async (
  agencyId,
  referenceId,
  userId,
) => {
  const response = await api.patch(`/sm/teams/${agencyId}/utilityprovider`, {
    referenceID: referenceId,
    teamMemberID: userId,
  })

  return response.data
}

/**
 * Get utility provider information for an agency
 * @param {string} agencyId - The agency ID
 * @returns {Promise} API response with utility provider data
 */
export const getUtilityProviderInfo = async (agencyId) => {
  const response = await api.get(`/sm/agencies/${agencyId}/utilityprovider`)
  return response.data
}

/**
 * Create/set utility provider reference ID for an agency (for all team members)
 * @param {string} agencyId - The agency ID
 * @param {string} referenceId - The reference ID to set
 * @returns {Promise} API response with created reference ID
 */
export const createUtilityProviderReferenceId = async (
  agencyId,
  referenceId,
) => {
  const response = await api.post(
    `/sm/teams/${agencyId}/utilityprovider/bulk`,
    {
      referenceID: referenceId,
    },
  )

  return response.data
}
